<script setup lang="ts">
import { info, warning } from '@/components/icons/icons.ts';
import { TabIndicatorState } from '@/components/Tabs/types.ts';

defineProps<{
  title?: string;
  indicatorState?: TabIndicatorState;
}>();
</script>

<template>
  <span :class="{ [`text-${indicatorState}`]: indicatorState }">
    <slot>{{ title }}</slot>
    <v-icon
      v-if="indicatorState"
      class="tab-indicator-icon"
      :icon="indicatorState === TabIndicatorState.INFO ? info : warning"
      size="small"
      :class="{
        'text-info': indicatorState === TabIndicatorState.INFO,
      }"
    />
  </span>
</template>

<style scoped>
.tab-indicator-icon {
  vertical-align: top;
  margin-top: -2px;
  margin-left: 4px;
}
</style>
